import React, { useEffect } from "react";
import { Modal, Input, Form, message } from "antd";
import { InjectBaseModalProps } from "@/hooks/Modal/ModalStore";
import { getRequiredRule } from "@/util/formValidatorRules";
import { trimStringValueNormalize } from "@/util/formNormalizes";
import { useRequest } from "ahooks";
import { updateConsumerName } from "@/services/api/sharedEwaybillShippingAddress";
import { SharedEwaybillShippingAddress } from "@/services/api/sharedEwaybillAccount";

export interface ChangeNickNameModalProps extends InjectBaseModalProps {
  reload?(): void;

  shippingAddress: SharedEwaybillShippingAddress;
}

const ChangeNickNameModal: React.FC<ChangeNickNameModalProps> = function (props) {
  const { visible, onCancel, shippingAddress, reload } = props;

  const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldsValue({
      consumerName: shippingAddress?.consumerName,
    });
  }, []);

  const { run, loading } = useRequest(
    async () => {
      const values = await form.validateFields();

      const result = await updateConsumerName(shippingAddress.id, values.consumerName);

      if (result?.successful) {
        message.success({
          content: "修改备注成功",
          duration: 3,
        });

        onCancel();
        reload?.();
      } else {
        message.error({
          content: "修改备注失败",
        });
      }
    },
    {
      manual: true,
    }
  );

  return (
    <Modal title="修改备注" visible={visible} confirmLoading={loading} onOk={run} onCancel={onCancel}>
      <Form form={form}>
        <Form.Item name="consumerName" normalize={trimStringValueNormalize} rules={[getRequiredRule("备注必须填写")]}>
          <Input placeholder="请输入"></Input>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default React.memo(ChangeNickNameModal);
